<template>
  <section>
    <div class="ml-3" v-for="item in items" :key="item.tableauMenuFolderId">
      <div class="folder-container">
        <span class="title-box" :title="item.title">
          <b-icon-folder/>
          {{ item.title }}
        </span>
      </div>
      <div class="ml-3">
        <div v-for="report in item.reports" :key="report.tableauMenuConfigId">
<!--          <div class="title-box clickable" @click="selectedReport(report.tableauMenuConfigId)">-->
<!--            <b-icon-file-earmark-bar-graph/>-->
<!--            {{report.title}}-->
<!--          </div>-->
          <router-link class="title-box clickable" :to="`/reports/${report.tableauMenuConfigId}`" >
            <b-icon-file-earmark-bar-graph/>
            {{report.title}}
          </router-link>
        </div>
      </div>
      <tree-node class="ml-3" v-if="item.children && item.children.length" :items="item.children"/>
    </div>
    <div class="ml-3">
      <div v-for="report in reports" :key="report.tableauMenuConfigId">
        <router-link class="title-box clickable" :to="`/reports/${report.tableauMenuConfigId}`">
          <b-icon-file-earmark-bar-graph/>
          {{report.title}}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TreeNode",
  props: {items: Array, reports: Array},
  methods: {
    // selectedReport(id) {
    //   // this.$emit('selectedReport', id);
    // }
  }
}
</script>

<style scoped>
.icon-button {
  visibility: hidden;
  display: inline-block;
  cursor: pointer;
  float: right;
  vertical-align: bottom;
  z-index: 10;
}

.title-box {
  display: inline-block;
  width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title-box:visited {
  color: inherit !important;
}

.title-box:focus {
  color: inherit !important;
}

.title-box:hover {
  color: inherit !important;
  text-decoration: none !important;
}
</style>